export type CostScaling = { a: number; b: number };

export function scaleCost(
    base: Record<string, number>,
    count: number,
    scaling: CostScaling,
): Record<string, number> {
    const n = Math.max(1, count);
    const factor = 1 + scaling.a * (n - 1) + scaling.b * (n - 1) * (n - 1);
    return Object.entries(base).reduce<Record<string, number>>((acc, [key, value]) => {
        acc[key] = Math.ceil(value * factor);
        return acc;
    }, {});
}
